<template>
	<modal class="integration-modal" size="large" @close="close">
		<template slot="header">
			<h3><i class="material-icons">edit</i>Product Update</h3>
		</template>
		<template slot="body">
			<!-- <div class="alert alert-warning d-flex align-items-center mb-2" :class="{ 'hidden': !isShowAlertInfo }">
				<span>{{ $t('Please be aware, that this update will affected to added product in Orderonline.') }}</span>
			</div> -->
			<div class="alert alert-warning d-flex align-items-center mb-2" v-if="isTypeCommission">
				<span>Nilai Komisi akan berefek pada harga coret di katalog.</span>
			</div>
			<div class="form-group mb-1 old hidden">
				<label>{{ $t('Commission') }}</label>
				<div class="input-group d-flex align-items-center">
					<price-input class="input form-control" placeholder="Masukan Persentase"
						@input="checkCommisionPecentage" @change="checkCommisionPecentage" min="5" max="100"
						v-model="commissionPercentage"></price-input>
					<div class="input-group-append">
						<div class="input-group-text">%</div>
					</div>
				</div>
			</div>
			<template v-if="productType === 'simple'">
				<div>
					<div class="row" :class="{ 'hidden': type !== 'commission' }">
						<div class="form-group col-lg-6 mb-2 mt-2">
							<select class="form-control" v-model="outsourceCommission.type">
								<option value="percentage">Persentase</option>
								<option value="nominal">Nominal</option>
							</select>
						</div>
						<div class="form-group col-lg-6 mb-3 mt-2">
							<div class="input-group d-flex align-items-center">
								<div class="input-group-prepend" v-if="outsourceCommission.type === 'nominal'">
									<div class="input-group-text">
										{{ currencySymbol }}
									</div>
								</div>
								<price-input
									type="text"
									class="input form-control"
									min="0"
									v-model.number="outsourceCommission.value"
								/>
								<div class="input-group-append" v-if="outsourceCommission.type === 'percentage'">
									<div class="input-group-text">
										%
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-if="productType === 'variable' && productVariations">
				<div class="row d-flex align-items-center my-4 py-3 mx-0 apply-to-all" :class="{ 'hidden': type !== 'commission' }">
					<div class="col-md-3 my-2">
						Ubah Semua Commission
					</div>
					<div class="col-md-9">
						<div class="row d-flex align-items-center">
							<div class="form-group col-md my-2">
								<select class="form-control"
								v-model="globalOutsourceCommission.type"
								>
									<option value="percentage">Persentase</option>
									<option value="nominal">Nominal</option>
								</select>
							</div>
							<div class="form-group col-md my-2">
								<div class="input-group d-flex align-items-center">
									<div class="input-group-prepend"
										v-if="globalOutsourceCommission.type === 'nominal'">
										<div class="input-group-text">
											{{ currencySymbol }}
										</div>
									</div>
									<price-input
										type="text"
										class="input form-control"
										min="0"
										v-model.number="globalOutsourceCommission.value"
									/>
									<div class="input-group-append"
										v-if="globalOutsourceCommission.type === 'percentage'">
										<div class="input-group-text">
											%
										</div>
									</div>
								</div>
							</div>
							<div class="form-group col-md-auto my-2 d-flex justify-content-end">
								<button class="btn-outline o-sm outline-primary" @click="applyToAllVariations('commission')">
									<span class="px-2">Terapkan</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="row" :class="{ 'hidden': type !== 'commission' }">
						<table class="table table-bordered" :class="{ 'hidden': type !== 'commission' }">
							<thead>
								<tr>
									<th>Variasi</th>
									<th>Commission</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(variationPrice, index) in productVariations.prices" :key="index">
									<td>{{ displayVariationName(variationPrice.name) }}</td>
									<td>
										<div class="row">
											<div class="form-group col-lg-6 mb-2 mt-2">
												<select class="form-control"
												v-model="variationPrice.outsource_commission.type"
												>
													<option value="percentage">Persentase</option>
													<option value="nominal">Nominal</option>
												</select>
											</div>
											<div class="form-group col-lg-6 mb-3 mt-2">
												<div class="input-group d-flex align-items-center">
													<div class="input-group-prepend"
														v-if="variationPrice.outsource_commission.type === 'nominal'">
														<div class="input-group-text">
															{{ currencySymbol }}
														</div>
													</div>
													<price-input
														type="text"
														class="input form-control"
														min="0"
														v-model.number="variationPrice.outsource_commission.value"
													/>
													<div class="input-group-append"
														v-if="variationPrice.outsource_commission.type === 'percentage'">
														<div class="input-group-text">
															%
														</div>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</template>

			<template>
				<stock-management
					:class="{ 'hidden': type !== 'stock' }"
					:product="product"
				></stock-management>
			</template>

			<!-- Margin -->
			<template v-if="productType === 'simple'">
				<div class="form-group mb-1" :class="{ 'hidden': type !== 'margin' }">
					<label>{{ $t('Margin') }}</label>
					<div class="input-group d-flex align-items-center">
						<div class="input-group-prepend">
							<div class="input-group-text">Rp</div>
						</div>
						<price-input class="input form-control" placeholder="Masukan Margin untuk Drophipper" min="0"
							v-model="margin"></price-input>
					</div>
				</div>
			</template>
			<template v-if="productType === 'variable' && productVariations !== null">
				<div class="row d-flex align-items-center my-4 py-3 mx-0 apply-to-all" :class="{ 'hidden': type !== 'margin' }">
					<div class="col-md-6 my-2">
						Ubah Semua Margin
					</div>
					<div class="col-md-6 d-flex my-2">
						<div class="input-group d-flex align-items-center">
							<div class="input-group-prepend">
								<div class="input-group-text">Rp</div>
							</div>
							<price-input class="input form-control mr-2" placeholder="Masukan Margin untuk Drophipper" min="0"
								v-model="globalMargin"
							></price-input>
							<button class="btn-outline o-sm outline-primary" @click="applyToAllVariations('margin')">
								<span class="px-2">Terapkan</span>
							</button>
						</div>
					</div>
				</div>
				<table class="table table-bordered" :class="{ 'hidden': type !== 'margin' }">
					<thead>
						<tr>
							<th>Variasi</th>
							<th>Margin</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(variationPrice, index) in productVariations.prices" :key="index">
							<td>{{ displayVariationName(variationPrice.name) }}</td>
							<td>
								<div class="input-group d-flex align-items-center">
									<div class="input-group-prepend">
										<div class="input-group-text">Rp</div>
									</div>
									<price-input class="input form-control" placeholder="Masukan Margin untuk Drophipper" min="0"
										v-model="variationPrice.margin"
									></price-input>
									<!-- <div class="input-group-append" v-if="index == 0" role="button" @click="applyAll();">
										<span class="input-group-text">
											<i class="material-icons md-sm">filter_none</i>
										</span>
									</div> -->
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</template>

			<!-- Product Sourcing Fee - Start -->
			<div v-if="type === 'product_sourcing_fee'">
				<div class="form-group">
					<label>{{ $t('Product Sourcing Fee') }}</label>
					<div class="input-group d-flex align-items-center">
						<price-input
							class="input form-control"
							placeholder="Masukkan Nilai"
							min="0"
							v-model="productSourcingFee.value"
						/>
						<div class="input-group-append">
							<div class="input-group-text">
								%
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Product Sourcing Fee - End -->

			<div class="form-group mb-2" :class="{ 'hidden': type !== 'marketing_kit' }">
				<label>{{ $t('Link Download') }}</label>
				<input type="text" class="input form-control" placeholder="Masukan link download marketing kit"
					v-model.trim="marketingKit.link" />
			</div>
			<div class="form-group mb-2" :class="{ 'hidden': type !== 'marketing_kit' }">
				<label>{{ $t('Description') }}</label>
				<textarea type="textarea" class="input form-control" placeholder="Masukan deskripsi marketing kit"
					v-model="marketingKit.description" />
			</div>
			<div class="form-group mb-2" :class="{ 'hidden': type !== 'marketing_kit' }">
				<label class="label-toggle d-block">
					<input type="checkbox" class="toggle" v-model="marketingKit.visible">
					<div class="toggle-btn d-inline-block"></div>
					<span class="label-toggle-text ml-2">
						{{ $t('Show Marketing Kit') }}
					</span>
				</label>
			</div>
			<div :class="{ 'hidden': type !== 'product_detail' }">
				<div class="form-group mb-2">
					<div class="box__content">
						<div class="pc-images-list">
							<draggable
								draggable=".draggable"
								v-model="productImageViews"
								v-bind="dragOptions"
								@start="drag = true"
								@end="drag = false"
							>
								<transition-group
									class="upload-image-container"
									type="transition"
									:name="!drag ? 'flip-list' : null"
								>
									<div
										class="image-wrapper"
										:class="{ draggable: image !== '' }"
										v-for="(image, index) in productImageViews"
										:key="index + 0"
									>
										<div
											v-if="isLoading[index] && image === ''"
											class="pc-image-empty"
										>
											<div class="image-loading">
												<div class="is-loading"></div>
											</div>
										</div>
										<div
											v-else-if="image === ''"
											class="pc-image-empty cursor-pointer h-100"
											@click="uploadImages(index)"
											@dragover.prevent="handleDragOver"
											@dragenter.prevent="handleDragEnter"
											@dragleave.prevent="handleDragLeave"
											@drop.prevent="(event) => handleDrop(event, index)"
										>
											<div class="image-upload-placeholder">
												<i
													class="fi fi-rr-picture image-placeholder"
												></i>
												<div class="text-placeholder">
													Foto {{ index + 1 }}
												</div>
											</div>
										</div>
										<div
											v-else
											class="pc-image h-100"
											:class="{
												'is-loading': image === '',
											}"
										>
											<div
												class="img"
												:style="{ backgroundImage: `url('${image}')` }"
											></div>
											<i
												class="material-icons"
												v-tooltip="'Remove'"
												@click="removeProductImages(index)"
												>close</i
											>
										</div>
									</div>
								</transition-group>
							</draggable>
						</div>
					</div>
				</div>
				<div class="form-group buttons m-0 hidden">
					<input
						type="file"
						accept="image/*"
						class="input-file"
						ref="imageUploader"
						id="pc-product-images-file"
						@change="onProductImagesChange"
					/>
					<label
						for="pc-product-images-file"
						class="btn btn-primary"
						:class="{ 'is-loading': product.isUploading }"
						>Upload images</label
					>
					<div class="pc-input-desc">
						You can choose to show or hide product images on
						Checkout Page section
					</div>
				</div>
				<div class="form-group buttons m-0 hidden">
					<input
						type="file"
						class="input-file"
						ref="fileUploader"
						id="pc-product-images-file"
						@change="onFileChange"
					/>
					<label
						for="pc-product-images-file"
						class="btn btn-primary"
						:class="{ 'is-loading': product.isUploading }"
						>Upload images</label
					>
					<div class="pc-input-desc">
						You can choose to show or hide product images on
						Checkout Page section
					</div>
				</div>
				<div class="form-group mb-2">
					<label>{{ $t('Product Name') }}</label>
					<input
						type="text"
						class="input form-control"
						:class="{ error: isFieldError('product', 'name') }"
						@input="onProductNameChange"
						v-model.trim="productName"
					/>
					<div class="pc-input-desc text-danger" v-if="isFieldError('product', 'name')">
						Nama Produk Wajib Diisi
					</div>
				</div>
				<div class="form-group mb-2">
					<label>{{ $t('Description') }}</label>
					<content-editor v-model="description" from="funnel"></content-editor>
				</div>
				<div class="form-group mb-2">
					<label>{{ $t('URL Landing Pages') }}</label>
					<landing-page-editor :product-pages="productPages" @add-preview="addPreview" @remove-preview="removePreview"
						@add-lp="addLandingPage" @remove-lp="removeLandingPage"></landing-page-editor>
				</div>
				<div class="form-group mb-2">
					<label>{{ $t('Category') }}</label>
					<product-category
						:data="productCategory"
						:label="false"
						@change="onCategoryChange"
						:error="isFieldError('product', 'category')"
					>
					</product-category>
				</div>
			</div>

			<!-- Visibility - Start -->
			<div :class="{ 'hidden': type !== 'visibility' }">
				<div class="form-group mb-2">
					<label>{{ $t('Visibility') }}</label>
					<select class="form-control" v-model="visibility">
						<option value="public">Public</option>
						<option value="private">Private</option>
					</select>
				</div>
				<div class="form-group mb-2" v-if="visibility === 'private'">
					<label>{{ $t('Seller') }}</label>
					<multiselect
						v-model="selectedDropshippers"
						track-by="email"
						placeholder="Masukkan Nama Seller"
						:custom-label="dropshipperLabel"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
						:options="dropshippers"
						@search-change="fetchDropshippers"
					>
						<template slot="selection" slot-scope="{ values, isOpen }">
							<span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span>
						</template>
					</multiselect>

					<div class="products-list mt-2 table-responsive" v-if="selectedDropshippers.length > 0">
						<table class="products-list-table table table-primary table-striped">
							<thead>
								<tr>
									<th>No</th>
									<th>Name</th>
									<th>Email</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(dropshipper, idx) in selectedDropshippers" :key="dropshipper.user_id">
									<td>{{ idx + 1 }}</td>
									<td>{{ dropshipper.name }}</td>
									<td>{{ dropshipper.email }}</td>
									<td class="text-center" @click="removeDropshipper(dropshipper.user_id)">
										<i class="material-icons has-tooltip cursor-pointer text-danger"
											v-tooltip="'Remove Seller'">
											delete
										</i>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<!-- Visibility - End -->

			<!-- Max Qty - Start -->
			<div v-if="type === 'max_qty'">
				<div class="row">
					<div class="col-auto d-flex align-items-center">
						<smart-toggle
							v-model="maxQty.enabled"
							label="Aktifkan max quantity?"
							@input="onChangeMaxQuantityEnabled"
						/>
					</div>
					<div class="col">
						<price-input
							class="input form-control"
							placeholder="Masukkan Nilai"
							min="1"
							v-model="maxQty.value"
						/>
					</div>
				</div>
			</div>
			<!-- Max Qty - End -->

			<!-- Blacklisted Sellers - Start -->
			<div :class="{ 'hidden': type !== 'blacklisted_sellers' }">
				<div class="form-group mb-2">
					<multiselect-dropshipper
						:label="'Blacklisted Sellers'"
						:selected-dropshippers.sync="selectedDropshippers"
					/>
					<table-dropshipper
						class="mt-2"
						:selected-dropshippers.sync="selectedDropshippers"
					/>
				</div>
			</div>
			<!-- Blacklisted Sellers - End -->

			<!-- Distributor Status - Start -->
			<div v-if="type === 'distributor_status'">
				<div class="alert alert-warning d-flex align-items-center mb-4">
					<span>Jika diaktifkan akan mengubah status produk menjadi Verification/Updated</span>
				</div>
				<div class="form-group mb-2">
					<smart-toggle
						:info="'Hanya bisa diaktifkan untuk Produk Simple'"
						:disabled="product.type === 'variable'"
						v-model="isDistributorPriceEnabled"
						label="Aktifkan harga wholesale?"
						@input="onChangeDistributorPrice"
					/>
				</div>
			</div>
			<!-- Distributor Status - End -->

			<!-- Distributor Price - Start -->
			<div v-if="type === 'distributor_price'">
				<div class="form-group">
					<label>{{ $t('Wholesale Base Price') }}</label>
					<div class="input-group d-flex align-items-center">
						<div class="input-group-prepend">
							<div class="input-group-text">Rp</div>
						</div>
						<price-input
							class="input form-control"
							placeholder="Masukan Harga"
							min="0"
							v-model="distriPrice"
						/>
					</div>
				</div>
			</div>
			<!-- Distributor Price - End -->

			<!-- Distributor Slash Price - Start -->
			<div v-if="type === 'distributor_slash_price'">
				<div class="alert alert-warning d-flex align-items-center mb-2">
					<span>Nilai harga wholesale akan berubah saat harga coret diubah.</span>
				</div>
				<div class="form-group">
					<label>{{ $t('Slash Price') }}</label>
					<div class="input-group d-flex align-items-center">
						<div class="input-group-prepend">
							<div class="input-group-text">Rp</div>
						</div>
						<price-input
							class="input form-control"
							placeholder="Masukan Harga Coret"
							min="0"
							v-model="slashPrice"
						/>
					</div>
					<div class="pc-input-desc text-danger" v-if="isFieldError('product', 'distributor_wholesale')">
						Terdapat error pada harga wholesale akibat perubahan harga coret
					</div>
					<div class="pc-input-desc text-danger" v-if="isFieldError('product', 'distributor_slash_price')">
						{{ distributorSlashPriceErrorMessage }}
					</div>
				</div>
			</div>
			<!-- Distributor Slash Price - End -->

			<!-- Distributor Wholesale Price - Start -->
			<div v-if="type === 'distributor_wholesale_price'">
				<div class="form-group mb-2">
					<table>
						<tr>
							<td>Status</td>
							<td><span class="mx-2">:</span></td>
							<td>
								<span class="text-success" v-if="distributorStatus">Enabled</span>
								<span class="text-danger" v-else>Disabled</span>
							</td>
						</tr>
						<tr>
							<td>Harga</td>
							<td><span class="mx-2">:</span></td>
							<td>{{ distributorPrice }}</td>
						</tr>
						<tr>
							<td>Harga Coret</td>
							<td><span class="mx-2">:</span></td>
							<td>{{ distributorSlashPrice }}</td>
						</tr>
					</table>
					<div class="mt-2">
						<distributor-wholesale-price
							:wholesale="distributorWholesale"
							:slash-price="slashPrice"
							@update="updateWholesale"
						/>
					</div>
				</div>
			</div>
			<!-- Distributor Wholesale Price - End -->

			<!-- Distributor Stock - Start -->
			<stock-management
				v-if="type === 'distributor_stock'"
				:stock-type="'wholesale'"
				:product="product"
			/>
			<!-- Distributor Stock - End -->

			<!-- Distributor Visibility - Start -->
			<div v-if="type === 'distributor_visibility'">
				<div class="form-group mb-2">
					<label>{{ $t('Wholesale Visibility') }}</label>
					<select class="form-control" v-model="distributorVisibility">
						<option value="public">Public</option>
						<option value="private">Private</option>
					</select>
				</div>
				<div class="form-group mb-2" v-if="distributorVisibility === 'private'">
					<label>{{ $t('Seller') }}</label>
					<multiselect
						v-model="selectedDropshippers"
						track-by="email"
						placeholder="Masukkan Nama Seller"
						:custom-label="dropshipperLabel"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
						:options="dropshippers"
						@search-change="fetchDropshippers"
					>
						<template slot="selection" slot-scope="{ values, isOpen }">
							<span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span>
						</template>
					</multiselect>

					<div class="products-list mt-2 table-responsive" v-if="selectedDropshippers.length > 0">
						<table class="products-list-table table table-primary table-striped">
							<thead>
								<tr>
									<th>No</th>
									<th>Name</th>
									<th>Email</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(dropshipper, idx) in selectedDropshippers" :key="dropshipper.user_id">
									<td>{{ idx + 1 }}</td>
									<td>{{ dropshipper.name }}</td>
									<td>{{ dropshipper.email }}</td>
									<td class="text-center" @click="removeDropshipper(dropshipper.user_id)">
										<i class="material-icons has-tooltip cursor-pointer text-danger"
											v-tooltip="'Remove Seller'">
											delete
										</i>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<!-- Distributor Visibility - End -->
		</template>
		<template slot="footer">
			<button type="button" class="btn btn-default" :disabled="isUpdating" @click="close">
				Cancel
			</button>
			<button
				v-if="isShowUpdate"
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdating }"
				:disabled="!isFormValid"
				@click="updateProduct"
			>
				Update
			</button>
		</template>

		<!-- Notifications -->
		<notifications
			group="productUpdateModal"
			position="bottom right"
		></notifications>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import PriceInput from '@/components/PriceInput.vue';
import Loader from '@/components/Loader.vue';
import LandingPageEditor from '@/components/LandingPageEditor.vue';
import ProductCategory from '@/components/ProductCategory.vue';
import SmartToggle from '@/components/SmartToggle.vue';
import MultiselectDropshipper from '@/components/forms/MultiselectDropshipper.vue';
import StockManagement from '@/components/products/StockManagement.vue';
import DistributorWholesalePrice from '@/components/products/DistributorWholesalePrice.vue';
import TableDropshipper from '@/components/forms/TableDropshipper.vue';
import adminApi from '@/api/admin';
import mediaApi from '@/api/media';
import userApi from '@/api/user';
import {
	duplicateVar,
	formatMoney,
	getAxiosErrorMessage,
	slugify,
	validateDistributorWholesale,
} from '@/lib/helper';
import {
	defaultMaxQtyConfig,
	defaultMarketingKit,
	defaultProduct,
	defaultMargin,
	defaultOutsourceCommision,
	defaultProductSourcingFeeConfig,
} from '@/lib/statics';

const ContentEditor = () => ({
	component: import(
		/* webpackChunkName: "content-editor" */ '@/components/ContentEditor.vue'
	),
	loading: Loader,
});

export default {
	name: 'ProductUpdateModal',
	props: {
		type: {
			type: String,
			default: 'commission',
		},
		product: {
			type: Object,
			default: null,
		},
	},
	components: {
		Modal,
		PriceInput,
		SmartToggle,
		ContentEditor,
		LandingPageEditor,
		ProductCategory,
		draggable,
		MultiselectDropshipper,
		StockManagement,
		DistributorWholesalePrice,
		TableDropshipper,
	},
	data() {
		return {
			isUpdating: false,
			commissionPercentage: 0,
			margin: 0,
			globalMargin: 0,
			marketingKit: duplicateVar(defaultMarketingKit),
			description: '',
			productPages: [],
			productSourcingFee: duplicateVar(defaultProductSourcingFeeConfig),
			outsourceCommission: {
				type: 'percentage',
				value: 5,
			},
			globalOutsourceCommission: {
				type: 'percentage',
				value: 5,
			},
			maxQty: duplicateVar(defaultMaxQtyConfig),
			productCategory: {},
			productVariations: null,
			visibility: 'public',
			dropshipperKeyword: '',
			dropshippers: [],
			selectedDropshippers: [],
			productName: '',
			productImageViews: duplicateVar(defaultProduct.images),
			dragOptions: {
				animation: 100,
			},
			drag: false,
			isLoading: [false, false, false, false, false, false, false, false, false, false],
			productImagesLimit: 10,
			isDistributorPriceEnabled: false,
			distriPrice: 0,
			slashPrice: 0,
			distributorWholesale: [],
			distributorVisibility: 'public',
		};
	},
	methods: {
		...mapActions({
			addStepError: 'productCreator/addStepError',
			removeStepError: 'productCreator/removeStepError',
			resetStepErrors: 'productCreator/resetStepErrors',
		}),
		excludeProperty(data, keyToExclude) {
			const excludedData = duplicateVar(data);
			const keys = Object.keys(excludedData);
			if (keys.includes(keyToExclude)) {
				delete data[keyToExclude];
			}

			return data;
		},
		dropshipperLabel({ name, email }) {
			return `${name} - ${email}`;
		},
		fetchDropshippers(query) {
			if (query.length >= 1) {
				this.dropshipperKeyword = query;
				this.getDropshippers();
			}
		},
		getDropshippers() {
			const params = {
				keyword: this.dropshipperKeyword,
				role: 'owner',
				owner_type: 'dropshipper', // seller
			};

			if (this.type === 'distributor_visibility') {
				params.feature = 'private_order';
			}

			const callback = (response) => {
				let dropshippers = response.data;

				if (dropshippers.length > 0) {
					dropshippers = dropshippers.map((data) => {
						const newObj = {};
						newObj.user_id = data._id;
						newObj.name = data.name;
						newObj.email = data.email;
						return newObj;
					});
				}

				this.dropshippers = dropshippers;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				console.log(msg);
			};
			userApi.getUsersMinimal(params, callback, errorCallback);
		},
		removeDropshipper(userId) {
			this.selectedDropshippers = this.selectedDropshippers.filter(dropshipper => dropshipper.user_id !== userId);
		},
		close() {
			this.$emit('close');
		},
		applyAll() {
			this.productVariations.prices.map((margin) => {
				const newMargin = margin;
				newMargin.margin = this.productVariations.prices[0].margin;
				return newMargin;
			});
		},
		applyToAllVariations(type) {
			this.productVariations.prices.map((variant) => {
				const updatedVariant = variant;

				if (type === 'margin') {
					updatedVariant.margin = this.globalMargin;
				} else if (type === 'commission') {
					updatedVariant.outsource_commission = this.globalOutsourceCommission;
				}

				return updatedVariant;
			});
		},
		submit() {
			this.isUpdating = true;
			const id = this.product._id;
			const params = this.generateFormParams();
			const callback = (response) => {
				const product = response.data;
				this.$emit('update', product);

				this.$notify({
					group: 'products',
					type: 'success',
					title: 'Success',
					text: 'Product has been updated',
				});

				this.$emit('close');
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				this.$notify({
					group: 'products',
					type: 'error',
					title: 'Failed',
					text: msg,
				});
				console.log(msg);
			};
			adminApi.updateProduct(id, params, callback, errorCallback);
		},
		generateFormParams() {
			const params = {
				type: this.type,
			};

			if (this.type === 'commission' && this.productType === 'simple') {
				params.commission_percentage = this.commissionPercentage;
				params.outsource_commission = JSON.stringify(this.outsourceCommission);
			}

			if (this.type === 'commission' && this.productType === 'variable') {
				params.variations = JSON.stringify(this.productVariations);

				if (this.productType === 'variable') {
					if (this.productVariations?.prices[0]?.outsource_commission) {
						params.outsource_commission = JSON.stringify(this.productVariations?.prices[0]?.outsource_commission);
					}
				}
			}

			if (this.type === 'product_sourcing_fee') {
				params.product_sourcing_fee = JSON.stringify(this.productSourcingFee);
			}

			if (this.type === 'margin') {
				params.margin = this.margin;

				if (this.productType === 'variable') {
					if (this.productVariations?.prices[0]?.margin) {
						params.margin = this.productVariations?.prices[0].margin;
					}
					this.productVariations = this.excludeProperty(this.productVariations, 'table');
					params.variations = JSON.stringify(this.productVariations);
				}
			}

			if (this.type === 'marketing_kit') {
				params.marketing_kit = JSON.stringify(this.marketingKit);
			}

			if (this.type === 'product_detail') {
				params.name = this.productName;
				params.slug = slugify(this.productName);
				params.description = this.description;
				params.pages = JSON.stringify(this.productPages);
				params.category = JSON.stringify(this.productCategory);
				params.pictures = JSON.stringify(this.filterNotEmpty(this.productImageViews));
			}

			if (this.type === 'visibility') {
				params.visibility = this.visibility;
				params.assigned_user = JSON.stringify(this.selectedDropshippers);
			}

			if (this.type === 'max_qty') {
				params.max_qty = JSON.stringify(this.maxQty);
			}

			if (this.type === 'blacklisted_sellers') {
				params.blacklisted_sellers = JSON.stringify(this.selectedDropshippers);
			}

			if (this.type === 'distributor_status') {
				params.distributor_status = this.isDistributorPriceEnabled;
			}

			if (this.type === 'distributor_price') {
				params.distributor_price = this.distriPrice;
			}

			if (this.type === 'distributor_slash_price') {
				params.distributor_slash_price = this.slashPrice;
				if (this.distributorWholesale?.length > 0) {
					params.wholesale = JSON.stringify(this.distributorWholesale);
				}
			}

			if (this.type === 'distributor_wholesale_price') {
				params.wholesale = JSON.stringify(this.distributorWholesale);
			}

			if (this.type === 'distributor_visibility') {
				params.distributor_visibility = this.distributorVisibility;
				params.distributor_assigned_user = JSON.stringify(this.selectedDropshippers);
			}

			return params;
		},
		setFormData() {
			if (this.product !== null) {
				this.commissionPercentage = this.product.commission_percentage;

				const outsourceCommission = this.product?.outsource_commission ?? defaultProduct.outsource_commission;
				this.outsourceCommission = duplicateVar(outsourceCommission);
				if (this.product?.outsource_commission === undefined) {
					this.outsourceCommission.value = this.commissionPercentage;
				}

				const psfConfig = this.product?.product_sourcing_fee ?? defaultProductSourcingFeeConfig;
				this.productSourcingFee = duplicateVar(psfConfig);

				this.margin = this.product.dropship.margin;
				this.productName = this.product.name;
				this.productImageViews = duplicateVar(this.product.pictures);
				this.productSlug = this.product.slug;
				this.description = this.product.description;
				this.productPages = this.product?.pages ?? [];
				this.productCategory = this.product?.category ?? {};

				this.marketingKit = duplicateVar(defaultMarketingKit);
				if (this.product.marketing_kit !== undefined) {
					this.marketingKit = this.product.marketing_kit;
				}

				this.maxQty = duplicateVar(this.product?.max_qty ?? defaultMaxQtyConfig);

				// Pictures
				const pictures = this.productImageViews.filter(picture => picture !== '');
				const limit = this.productImagesLimit - pictures.length;
				if (pictures.length < this.productImagesLimit) {
					for (let i = 0; i < limit; i++) {
						this.productImageViews.push('');
					}
				}

				const productVariations = duplicateVar(this.product.variations);
				if (this.productType === 'variable') {
					// check & add default margin each variation if not exist
					const fixVariationPriceProperties = (currPrice, idx) => {
						const hasMarginCodeProperty = Object.prototype.hasOwnProperty.call(
							currPrice,
							'margin',
						);
						if (!hasMarginCodeProperty) {
							const margin = this?.product?.dropship?.margin ?? defaultMargin;
							currPrice.margin = duplicateVar(margin);
						}
						const hasOutsourceCommision = Object.prototype.hasOwnProperty.call(
							currPrice,
							'outsource_commission',
						);
						if (!hasOutsourceCommision) {
							const outsourceCommission = this?.product?.outsource_commission ?? defaultOutsourceCommision;
							currPrice.outsource_commission = duplicateVar(outsourceCommission);
						}

						if (idx === 0) {
							const globalMargin = currPrice?.margin ?? defaultMargin;
							this.globalMargin = duplicateVar(globalMargin);

							const globalOutsourceCommission = currPrice?.outsource_commission ?? defaultOutsourceCommision;
							this.globalOutsourceCommission = duplicateVar(globalOutsourceCommission);
						}
					};
					productVariations.prices.forEach(fixVariationPriceProperties);
				}
				this.productVariations = productVariations;
				this.visibility = this.product?.visibility ?? 'public';
				this.distributorVisibility = this.product?.distributor?.visibility ?? 'public';
				this.selectedDropshippers = this.product?.assigned_user ?? [];
				if (this.type === 'blacklisted_sellers') {
					this.selectedDropshippers = this.product?.blacklisted_sellers ?? [];
				} else if (this.type === 'distributor_visibility') {
					this.selectedDropshippers = this.product?.distributor?.assigned_user ?? [];
				}

				this.isDistributorPriceEnabled = this.product?.distributor?.enabled ?? false;
				this.distriPrice = this.product?.distributor?.price ?? 0;
				this.slashPrice = this.product?.distributor?.slash_price ?? 0;
				this.distributorWholesale = this.product?.distributor?.wholesale ?? [];
			}
		},
		checkCommisionPecentage(val) {
			if (val < 5) {
				console.log(val);
			}
		},
		addPreview(value) {
			const { index, option } = value;
			this.productPages[index].previews.push(option);
		},
		removePreview(value) {
			const { index, i } = value;
			const prev = this.productPages[index].previews.splice(i, 1);
			if (this.productPages[index].previews.length !== 0) {
				this.$set(
					this.productPages[index],
					this.productPages[index].previews,
					prev,
				);
			}
		},
		addLandingPage(landingPage) {
			this.productPages.unshift(landingPage);
		},
		removeLandingPage(index) {
			this.productPages.splice(index, 1);
		},
		onCategoryChange(category) {
			if (category.type === 'category') {
				this.productCategory.category = category.name;
				this.productCategory.category_slug = category.slug;
			} else if (category.type === 'sub_category') {
				this.productCategory.sub_category = category.name;
				this.productCategory.sub_category_slug = category.slug;
			} else if (category.type === 'sub_sub_category') {
				this.productCategory.sub_sub_category = category.name;
				this.productCategory.sub_sub_category_slug = category.slug;
			}
			this.validateProductCategory(this.productCategory.category);
		},
		validateProductCategory(category) {
			const step = 'product';
			const key = 'category';
			if (category === '' || category === null || category === undefined
				|| category === 'Produk Lainnya' || category === 'Uncategorized') {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		onProductNameChange() {
			this.validateProductName(this.productName);
		},
		validateProductName(name) {
			const step = 'product';
			const key = 'name';
			const maxName = 100;
			if (name === '' || name.length > maxName) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		onChangeDistributorPrice(value) {
			this.isDistributorPriceEnabled = value;
		},
		onChangeMaxQuantityEnabled(value) {
			this.maxQty.enabled = value;
		},
		updateWholesale(wholesale) {
			this.distributorWholesale = wholesale;
		},
		validateDistributorWholesale,
		validateWholesale() {
			const errors = this.validateDistributorWholesale(this.distributorWholesale);
			const step = 'product';
			const key = 'distributor_wholesale';
			if (errors.min.length > 0
				|| errors.max.length > 0
				|| errors.discount.length > 0
				|| errors.price.length > 0) {
				const stepError = { step, key, error: errors };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		updateWholesalePrice() {
			if (this.distributorWholesale?.length > 0) {
				const wholesale = duplicateVar(this.distributorWholesale);
				wholesale.forEach((item, idx) => {
					const discount = item?.discount ?? 0;
					let priceAfterDiscount = this.slashPrice - Math.ceil(this.slashPrice * (discount / 100));
					priceAfterDiscount = Number(priceAfterDiscount) < 0 ? 0 : priceAfterDiscount;
					wholesale[idx].price = priceAfterDiscount;
				});
				this.distributorWholesale = wholesale;
				this.validateWholesale();
			}
		},
		validateDistributorSlashPrice() {
			const step = 'product';
			const key = 'distributor_slash_price';
			if (Number(this.slashPrice) <= 0) {
				const stepError = { step, key, error: 'Harga tidak valid' };
				this.addStepError(stepError);
			} else if (Number(this.slashPrice) <= Number(this.distriPrice)) {
				const stepError = { step, key, error: `Harga Coret harus lebih dari Harga HPP Wholesale ${formatMoney(this.distriPrice)}` };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateAllForm() {
			if (this.type === 'product_detail') {
				this.validateProductCategory(this.productCategory.category);
				this.validateProductName(this.productName);
			} else if (this.type === 'distributor_wholesale_price') {
				this.validateWholesale();
			} else if (this.type === 'distributor_slash_price') {
				this.validateDistributorSlashPrice();
				this.updateWholesalePrice();
			}
		},
		updateProduct() {
			this.validateAllForm();

			const currentStepErrors = this.stepErrors('product');
			const isHasErrors = Object.keys(currentStepErrors).length > 0;

			if (!isHasErrors) {
				this.submit();
			}
		},
		displayVariationName(name) {
			return name.replace(/\|\|/g, ' - ');
		},
		onFileChange(event) {
			// console.log('on file change');
			const productImages = this.filterNotEmpty(this.productImageViews);
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				if (isLimitReached) {
					console.log('Maximum 5 Images');
					const noticeMessage = 'Maksimum upload 5 foto produk';
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('file', image);
				uploadParams.append('resize', false);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					// this.$set(this.product.images, previewIndex, url);
					this.landingPage.url = url;
					this.addLandingPage();
					// console.log(url);
				};

				const errorCallback = (e) => {
					// eslint-disable-next-line
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadFile(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		onProductImagesChange(event) {
			const productImages = this.filterNotEmpty(this.productImageViews);
			this.isLoading[this.currentIndexUploadImage] = true;
			let isSuccess = true;
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				let fileType = image.type.split('/');
				fileType = fileType[fileType.length - 1];

				const validFileTypes = ['jpeg', 'jpg', 'png'];
				if (!validFileTypes.includes(fileType)) {
					const noticeMessage = 'File yang diupload tidak sesuai';
					this.$notify({
						group: 'products',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'products',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				if (isLimitReached) {
					const noticeMessage = `Maksimum upload ${this.productImagesLimit} foto produk`;
					this.$notify({
						group: 'products',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				const previewIndex = this.currentIndexUploadImage;

				this.$set(this.productImageViews, previewIndex, '');

				// Load the image file into a canvas element
				const img = new Image();
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const reader = new FileReader();
				reader.onload = () => {
					img.onload = () => {
						const size = Math.max(img.width, img.height);
						canvas.width = size;
						canvas.height = size;
						const offsetX = (size - img.width) / 2;
						const offsetY = (size - img.height) / 2;
						ctx.fillStyle = '#fff';
						ctx.fillRect(0, 0, size, size); // fill the canvas with white
						ctx.drawImage(img, offsetX, offsetY);

						// Convert the canvas to a blob and upload it to the server
						canvas.toBlob((blob) => {
							// Start Upload
							const uploadParams = new FormData();
							uploadParams.append('image', blob);

							const callback = (response) => {
								this.isLoading[this.currentIndexUploadImage] = false;
								const path = response.data;
								const url = `${this.mediaUrlPrefix}/${path}`;
								this.$set(this.productImageViews, previewIndex, url);
							};

							const errorCallback = () => {
								console.log('error callback');
								this.isLoading[this.currentIndexUploadImage] = false;
								// eslint-disable-next-line
								this.productImageViews.splice(previewIndex, 1);
							};

							// Upload Image
							mediaApi.uploadImage(uploadParams, callback, errorCallback);
						}, image.type, 0.9);
					};
					img.src = reader.result;
				};
				reader.readAsDataURL(image);
			}
			event.target.files = null;
			event.target.value = '';
			return isSuccess;
		},
		handleDragOver(event) {
			event.preventDefault();
		},
		handleDragEnter(event) {
			event.preventDefault();
			event.currentTarget.classList.add('drag-over');
		},
		handleDragLeave(event) {
			event.preventDefault();
			event.currentTarget.classList.remove('drag-over');
		},
		handleDrop(event, index) {
			event.preventDefault();
			event.currentTarget.classList.remove('drag-over');
			const files = event.dataTransfer.files;
			if (files.length === 1) {
				this.currentIndexUploadImage = index;
				this.onProductImagesChange({ target: { files } });
			} else if (files.length > 1) {
				let uploadedIndex = 0;

				const handleBulkUpload = (startIndex) => {
					for (let i = startIndex; i < this.productImageViews.length; i++) {
						const item = this.productImageViews[i];
						// eslint-disable-next-line no-continue
						if (item !== '') continue;
						this.currentIndexUploadImage = i;

						const uploadResult = this.onProductImagesChange({ target: { files: [files[uploadedIndex]] } });
						uploadedIndex += 1;

						if (!uploadResult) {
							handleBulkUpload(i);
							return;
						}
					}
				};

				handleBulkUpload(0);

				if (uploadedIndex < files.length) {
					const noticeMessage = `Maksimum upload ${this.productImagesLimit} foto produk`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
				}
			}
		},
		uploadImages(index) {
			this.currentIndexUploadImage = index;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		removeProductImages(index) {
			this.productImageViews.splice(index, 1, '');
		},
		filterNotEmpty(arr) {
			let nonEmptyValues = arr.map(value => (value !== '' ? value : null));
			nonEmptyValues = nonEmptyValues.filter(value => value !== null);

			return nonEmptyValues;
		},
	},
	computed: {
		...mapGetters({
			currency: 'currency',
			isFieldError: 'productCreator/isFieldError',
			getErrorMessage: 'productCreator/getErrorMessage',
			stepErrors: 'productCreator/stepErrors',
		}),
		isFormValid() {
			return this.product;
		},
		isShowAlertInfo() {
			return this.type === 'commission' || this.type === 'margin' || this.type === 'product_detail' || this.type === 'stock';
		},
		isTypeCommission() {
			return this.type === 'commission';
		},
		currencySymbol() {
			return this.getCurrencySymbol(this.currency);
		},
		productType() {
			return this.product?.type ?? 'simple';
		},
		distributorStatus() {
			return this.product?.distributor?.enabled ?? false;
		},
		distributorPrice() {
			if (!this.distributorStatus) {
				return '-';
			}
			const price = this.product?.distributor?.price ?? null;
			return formatMoney(price);
		},
		distributorSlashPrice() {
			if (!this.distributorStatus) {
				return '-';
			}
			const price = this.product?.distributor?.slash_price ?? null;
			return formatMoney(price);
		},
		isShowUpdate() {
			const isShow = this.type !== 'stock' && this.type !== 'distributor_stock';

			return isShow;
		},
		distributorSlashPriceErrorMessage() {
			const currentStepErrors = this.stepErrors('product');
			return currentStepErrors?.distributor_slash_price ?? false;
		},
	},
	mounted() {
		this.setFormData();
		this.resetStepErrors();
	},
};
</script>

<style scoped lang="scss">
.apply-to-all {
	background-color: #E6F0F980;
	border-radius: 8px;
}

.upload-image-container {
	display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
	gap: 12px;

	& > .image-wrapper {
		width: 100%;
		aspect-ratio: 1;
	}
}
</style>
